import { render, staticRenderFns } from "./ProductsAndInventoriesFileLoader.vue?vue&type=template&id=7d8517c9&"
import script from "./ProductsAndInventoriesFileLoader.vue?vue&type=script&lang=js&"
export * from "./ProductsAndInventoriesFileLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports